import { render } from "./LabelCard.vue?vue&type=template&id=e9916bf0"
import script from "./LabelCard.vue?vue&type=script&lang=js"
export * from "./LabelCard.vue?vue&type=script&lang=js"

import "./LabelCard.vue?vue&type=style&index=0&id=e9916bf0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__